module.exports = __webpack_public_path__ + "static/media/title.2507b308.png";